export default {
  flowsDefinitions: {},
  flowsDefinitionsUI: {},
  flows: [],
  flowsMeta: {},
  flowData: {},
  flowDataBackup: {},
  errorUpdatingFlow: null,
  updatingFlow: false,
  blocksCount: {},
  toggleElement: {},
};
